import {useDispatch, useSelector} from "react-redux";
import {
    airtable_config_get_label,
    exclusiveChange,
    hotDealChange, mobile_filter,
    mobileTrackingChange
} from "../redux/actions";
import React from "react";
import {Categoriesfilter} from "./Categoriesfilter";
import {ResetFilter} from "./ResetFilter";

export const Filters = () => {
    const dispatch = useDispatch()
    const mobile_tracking = useSelector(state => state.app.mobile_tracking)
    const exclusive = useSelector(state => state.app.exclusive)
    const hot_deal = useSelector(state => state.app.hot_deal)
    const airconfig = useSelector(state => state.app.airconfig)
    const isMobile = useSelector(state => state.app.isMobile)
    const mobileFilter = useSelector(state => state.app.mobileFilter)
    const app_lang = useSelector(state => state.app.app_lang)
    const handleSelectCheckbox = (checked, type) => {
        if (type === 1) {
            dispatch(mobileTrackingChange(checked));
        }
        if (type === 2) {
            dispatch(exclusiveChange(checked));
        }
        if (type === 3) {
            dispatch(hotDealChange(checked));
        }
    }
    const btn_text1 = airtable_config_get_label(airconfig, 'mobile_tracking_checkbox', app_lang);
    const hint1 = airtable_config_get_label(airconfig, 'mobile_tracking_hint', app_lang);
    const btn_text2 = airtable_config_get_label(airconfig, 'travelpayouts_exclusive_checkbox', app_lang);
    const hint2 = airtable_config_get_label(airconfig, 'travelpayouts_exclusive_hint', app_lang);
    const btn_text3 = airtable_config_get_label(airconfig, 'hot_deal_checkbox', app_lang);
    const hint3 = airtable_config_get_label(airconfig, 'hot_deal_hint', app_lang);
    const handleShowFilterBtn = (checked) => {
        dispatch(mobile_filter(checked))
    }
    if (isMobile) {
        return (
            <React.Fragment>
                <div className="show-filter-btn" onClick={() => handleShowFilterBtn(mobileFilter)}>
                    {airtable_config_get_label(airconfig, 'filters__title', app_lang)}
                </div>
                {
                    mobileFilter === true && (
                        <div className="mobile-filter-popup container">
                            <div className="mobile-filter-popup__box container__wrap">
                                <div className="mobile-filter-popup__title">
                                    Filters
                                </div>
                                <Categoriesfilter/>
                                <div className="filters__items">
                                    <div className="filters__item">
                                        <label className="filters__checkbox">
                                            <input type="checkbox" name="mobile-tracking" value="1"
                                                   onChange={() => handleSelectCheckbox(mobile_tracking, 1)}
                                                   checked={mobile_tracking}
                                            />
                                            <span>{btn_text1}</span>

                                        </label>
                                        {
                                            hint1 && (
                                                <div className="hint-icon">
                                                    <div className="hint-icon__message">{hint1}</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="filters__item">
                                        <label className="filters__checkbox">
                                            <input type="checkbox" name="mobile-tracking" value="1"
                                                   onChange={() => handleSelectCheckbox(exclusive, 2)}
                                                   checked={exclusive}
                                            />
                                            <span>{btn_text2}</span>

                                        </label>
                                        {
                                            hint2 && (
                                                <div className="hint-icon">
                                                    <div className="hint-icon__message">{hint2}</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="filters__item">
                                        <label className="filters__checkbox">
                                            <input type="checkbox" name="mobile-tracking" value="1"
                                                   onChange={() => handleSelectCheckbox(hot_deal, 3)}
                                                   checked={hot_deal}
                                            />
                                            <span>{btn_text3}</span>

                                        </label>
                                        {
                                            hint3 && (
                                                <div className="hint-icon">
                                                    <div className="hint-icon__message">{hint3}</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <ResetFilter/>
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        )
    }
    return (
        <div className="filters">
            <div className="filters__title">{airtable_config_get_label(airconfig, 'filters__title', app_lang)}</div>
            <div className="filters__items">
                <div className="filters__item">
                    <label className="filters__checkbox">
                        <input type="checkbox" name="mobile-tracking" value="1"
                               onChange={() => handleSelectCheckbox(mobile_tracking, 1)}
                               checked={mobile_tracking}
                        />
                        <span>{btn_text1}</span>

                    </label>
                    {
                        hint1 && (
                            <div className="hint-icon">
                                <div className="hint-icon__message">{hint1}</div>
                            </div>
                        )
                    }
                </div>
                <div className="filters__item">
                    <label className="filters__checkbox">
                        <input type="checkbox" name="mobile-tracking" value="1"
                               onChange={() => handleSelectCheckbox(exclusive, 2)}
                               checked={exclusive}
                        />
                        <span>{btn_text2}</span>

                    </label>
                    {
                        hint2 && (
                            <div className="hint-icon">
                                <div className="hint-icon__message">{hint2}</div>
                            </div>
                        )
                    }
                </div>
                <div className="filters__item">
                    <label className="filters__checkbox">
                        <input type="checkbox" name="mobile-tracking" value="1"
                               onChange={() => handleSelectCheckbox(hot_deal, 3)}
                               checked={hot_deal}
                        />
                        <span>{btn_text3}</span>

                    </label>
                    {
                        hint3 && (
                            <div className="hint-icon">
                                <div className="hint-icon__message">{hint3}</div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}